import React from 'react'
import { css } from '@linaria/core'

const connectorCss = css`
  transform: translateX(12px);
  height: 100%;
  width: 1.5px;
  background: black;
  opacity: 0.2;
`

/**
 * Connector component for WorldEvents info card.
 * @returns {JSX} Component
 */
export default function EventConnector() {
  return <div className={connectorCss} />
}
